import { Menu, MenuItem, MenuButton, SubMenu } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";
import { useSelector } from "react-redux";
import moment from "moment";

export default function Hammenu({ item, hoverId, setAction, listType }) {
  const state = useSelector((state) => state.UserReducer);
  const current_time = moment().format("yyyy-MM-DDTHH:mm:ss");

  return (
    <Menu
      menuButton={
        <MenuButton>
          <span
            className={`mr-1 -mt-1.5 cursor-pointer font-bold text-lg duration-300 ${
              item?._id === hoverId ? "opacity-100" : "opacity-20"
            }`}>
            ...
          </span>
        </MenuButton>
      }
      transition>
      {listType === "now" && (
        <MenuItem
          onClick={(event) => {
            setAction(item?._id, "Edit");
          }}>
          Edit
        </MenuItem>
      )}
      {listType === "now" && (
        <MenuItem
          onClick={(event) => {
            setAction(item?._id, "Delete");
          }}>
          Delete
        </MenuItem>
      )}
      {item?.notesTaker === state.user._id && (
        <MenuItem
          onClick={(event) => {
            setAction(item?._id, "MOM");
          }}>
          {item?.validflag === 1 ? "Fill MOM" : "Rewrite MOM"}
        </MenuItem>
      )}
    </Menu>
  );
}
